import httpStore from "@/api/httpStore.js";

// Camiones del sitio de NKR Motors Group (Costa Rica): series, modelos, ficha y
// galería. Los lee la tienda (nkrmotorsgroup-repuestos-fe) por web/trucks.

// Las imágenes y fichas son URLs del CDN de assets: las que vinieron del WordPress
// están en S3 bajo nkr_costa_rica/motors/camiones (migración de nkr-sequelize
// 20261016130000-trucks-images-to-s3) y las que se suben desde aquí, en upload/.
// Si queda alguna ruta relativa al sitio, para previsualizarla hace falta el dominio.
export const TRUCKS_SITE_URL = "https://www.nkrmotorsgroup.cr";

export function truckAssetUrl(url) {
  if (!url) return url;
  return url.startsWith("/") ? `${TRUCKS_SITE_URL}${url}` : url;
}

// Dónde se muestra cada fila de la ficha en el sitio.
export const SPEC_SECTIONS = [
  { value: "general", label: "Descripción" },
  { value: "summary", label: "Resumen" },
  { value: "highlight", label: "Destacados (franja)" },
  { value: "motor", label: "Motor" },
  { value: "transmision", label: "Transmisión y ejes" },
  { value: "chasis", label: "Chasis, suspensión y frenos" },
  { value: "cabina", label: "Cabina e interior" },
  { value: "dimensiones", label: "Dimensiones y capacidad de carga" },
  { value: "equipamiento", label: "Equipamiento estándar" }
];

function seriesToApi(series) {
  return {
    name: series.name,
    slug: series.slug,
    description: series.description,
    image_url: series.imageUrl,
    sort_order: series.sortOrder,
    status: series.status
  };
}

function truckToApi(truck) {
  return {
    series_id: truck.seriesId,
    name: truck.name,
    slug: truck.slug,
    description: truck.description,
    image_url: truck.imageUrl,
    datasheet_url: truck.datasheetUrl,
    featured: truck.featured,
    sort_order: truck.sortOrder,
    status: truck.status,
    meta_title: truck.metaTitle,
    meta_description: truck.metaDescription,
    specs: (truck.specs || []).map(spec => ({
      section: spec.section,
      label: spec.label,
      value: spec.value
    })),
    images: (truck.images || []).map(image => ({
      url: image.url,
      alt: image.alt
    }))
  };
}

export function getTrucks() {
  return httpStore.get("trucks").then(res => res.data);
}

export function getTruck(id) {
  return httpStore.get(`trucks/truck?id=${id}`).then(res => res.data);
}

export function saveTruck(truck) {
  const payload = { truck: truckToApi(truck) };
  const request = truck.id
    ? httpStore.put("trucks/truck", { id: truck.id, ...payload })
    : httpStore.post("trucks/truck", payload);
  return request.then(res => res.data);
}

export function deleteTruck(id) {
  return httpStore.delete(`trucks/truck?id=${id}`).then(res => res.data);
}

export function saveSeries(series) {
  const payload = { series: seriesToApi(series) };
  const request = series.id
    ? httpStore.put("trucks/series", { id: series.id, ...payload })
    : httpStore.post("trucks/series", payload);
  return request.then(res => res.data);
}

export function deleteSeries(id) {
  return httpStore.delete(`trucks/series?id=${id}`).then(res => res.data);
}
